"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basketCardEventStatusTestData = exports.eventsStatusBannerTestData = void 0;
const types_1 = require("astra-core/utils/events/types");
const testData_types_1 = require("../test-data/testData.types");
const basket_1 = require("../basket");
exports.eventsStatusBannerTestData = {
    [types_1.EEventsStatusList.CANCELED]: testData_types_1.ETestData.TestEventCanceled,
    [types_1.EEventsStatusList.INTERRUPTED]: testData_types_1.ETestData.TestEventInterrupted,
    [types_1.EEventsStatusList.POSTPONED]: testData_types_1.ETestData.TestEventPostponed,
    [types_1.EEventsStatusList.COMING]: testData_types_1.ETestData.TestEventComing,
    [types_1.EEventsStatusList.STATISTICS_NOT_AVAILABLE]: testData_types_1.ETestData.TestEventStatisticsNotAvailable,
    [types_1.EEventsStatusList.OUTCOMES_COMING]: testData_types_1.ETestData.TestEventOutcomesComing,
};
exports.basketCardEventStatusTestData = {
    [basket_1.EBasketCardEventStatusKey.EVENT_CANCELED]: testData_types_1.ETestData.TestBasketEventCanceled,
    [basket_1.EBasketCardEventStatusKey.EVENT_ENDED]: testData_types_1.ETestData.TestBasketEventEnded,
    [basket_1.EBasketCardEventStatusKey.EVENT_INTERRUPTED]: testData_types_1.ETestData.TestBasketEventInterrupted,
    [basket_1.EBasketCardEventStatusKey.EVENT_SUSPENDED]: testData_types_1.ETestData.TestBasketEventSuspended,
    [basket_1.EBasketCardEventStatusKey.EVENT_POSTPONED]: testData_types_1.ETestData.TestBasketEventPostponed,
    [basket_1.EBasketCardEventStatusKey.OUTCOME_NOT_AVAILABLE]: testData_types_1.ETestData.TestBasketOutcomeNotAvailable,
};
//# sourceMappingURL=constants.js.map